import React from 'react';
import { QuestionComponentProps } from '../QuestionComponent.types';
import { CustomQuestion } from '../Question';
import ExpertContentIcon from 'assets/livenicons/expert_level.png';
import ExpertQuality from 'assets/livenicons/expert_quality.svg';
import { StickyContainer } from 'components/stickycontainer/StickyContainer';
import Spacer from 'components/spacer/Spacer';
import { useAppDispatch } from 'bootstrap/hooks';
import { appAnalytics } from 'analytics';
import { goToNextQuestion } from 'bootstrap/onboarding/actions';
import { SaveAnswer } from 'analytics/AllEvents';
import { useFeatures } from 'useFeatures';

import styles from './styles.module.scss';

type Props = QuestionComponentProps<CustomQuestion>;

export const ExpertContent: React.FC<Props> = ({ question }: Props) => {
  const dispatch = useAppDispatch();
  const features = useFeatures();

  const nextButtonHandler = () => {
    setTimeout(() => {
      appAnalytics.trackEvent(new SaveAnswer(question.id));
      dispatch(goToNextQuestion(features));
    }, 250);
  };

  return (
    <div className={`${styles.container} maxWidth`}>
      <img src={ExpertContentIcon} className={styles.expertIcon} alt="" />
      <h3 className={styles.title}>
        Your plan will be reviewed by{' '}
        <span className={styles.accent}>practicing therapist</span>
      </h3>
      <p className={styles.description}>
        "Liven carefully uses a proven approach to provide personalized guidance
        and resources that support emotional resilience.”
      </p>
      <article className={styles.expertCard}>
        <div className={styles.label}>
          <p className="app-text p5">Content reviewed by an expert</p>
        </div>
        <div className={styles.content}>
          <img src={ExpertQuality} alt="" />
          <div className={styles.expertCardDescription}>
            <p>Anieta Dixon</p>
            <p className={styles.small}>Counselling Psychologist (M.A), SME</p>
          </div>
        </div>
      </article>
      <Spacer />
      <StickyContainer className={styles.buttonContainer}>
        <button className={styles.button} onClick={nextButtonHandler}>
          Continue
        </button>
      </StickyContainer>
    </div>
  );
};
